import { render, staticRenderFns } from "./TransferNanny.vue?vue&type=template&id=68631225&scoped=true"
import script from "./TransferNanny.vue?vue&type=script&lang=js"
export * from "./TransferNanny.vue?vue&type=script&lang=js"
import style0 from "./TransferNanny.vue?vue&type=style&index=0&id=68631225&prod&lang=css"
import style1 from "./TransferNanny.vue?vue&type=style&index=1&id=68631225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68631225",
  null
  
)

export default component.exports